import { LOCALE, type Locale } from '@/legacy-src/constants/locale.constants'
import { getFullDomain } from '@/legacy-src/utilities/languagesConfig'
import { sanitizeUrl } from '@/legacy-src/utilities/sanitizeUrl'

import { getRoute, type ExtractRouteParams } from './getRoute'

export const getRouteWithDomain = <S extends string>(
  pattern: S,
  params?: ExtractRouteParams<S> & { locale?: Locale },
): string => {
  const { locale = LOCALE, ...routeParams } = params ?? {}
  return sanitizeUrl(`${getFullDomain(locale)}${getRoute(pattern, routeParams as ExtractRouteParams<S>)}`)
}
